import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

/**
 * Button maps onto the original `.dock-btn` family from briefer.css.
 *   primary     → .dock-btn (teal, solid)
 *   default     → .dock-btn (same as primary; kept for compat)
 *   outline     → .dock-btn.ghost (transparent fill, bright border)
 *   ghost       → .dock-btn.ghost
 *   destructive → .dock-btn.danger
 */
const buttonVariants = cva('dock-btn', {
  variants: {
    variant: {
      default: '',
      primary: '',
      outline: 'ghost',
      ghost: 'ghost',
      destructive: 'danger',
    },
    size: {
      default: '',
      sm: 'dock-btn--sm',
      lg: 'dock-btn--lg',
      icon: 'dock-btn--icon',
    },
  },
  defaultVariants: { variant: 'default', size: 'default' },
})

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />
  ),
)
Button.displayName = 'Button'
